export const videoIds: Record<string, string> = {
  pt: "W_DLJ9TrXac",
  es: "Ylel93cMzt0",
  en: "oKo4J7Bm_c0",
};
